var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    _vm._g(
      _vm._b({ staticClass: "fc-badge" }, "div", _vm.$attrs, false),
      _vm.$listeners
    ),
    [
      _c(
        "div",
        {
          attrs: {
            tabindex: "0",
            "data-toggle": "popover",
            "data-trigger": "hover",
            "data-content": _vm.description,
          },
        },
        [
          _vm._v(
            " " + _vm._s(_vm.$t("pages.permission.calendarHolidayShort")) + " "
          ),
        ]
      ),
      _vm.withTitle
        ? _c("span", { staticClass: "ml-1" }, [
            _vm._v(_vm._s(_vm.$t("pages.permission.calendarHoliday"))),
          ])
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }